import { Action, createAction, handleActions } from "redux-actions";
import { calculateDate } from "~libs/dateCalculator";
import { queueMessage } from "~shared/snackbarsProvider/actions";
import { GetReporteNovedadesRequest } from "~api/types";
import {
  FechaFiltro,
  FiltroValue,
  ServicesReportes,
  TakeValue,
} from "../../types";

interface FiltrosNovedadesState {
  page: number;
  take: TakeValue;
  searchCriteria: string;
  inicioVigenciaDesde: FechaFiltro;
  inicioVigenciaHasta: FechaFiltro;
  fechaNovedadDesde: FechaFiltro;
  fechaNovedadHasta: FechaFiltro;
  negocio: FiltroValue;
  compania: FiltroValue;
  tipoNovedad: FiltroValue;
  buttonDescargaEnabled: boolean;
  buttonDescargaText: string;
}

const setPage = createAction("SET_LISTADO_NOVEDADES_PAGE", (page: number) => ({
  page,
}));

const setTake = createAction(
  "SET_LISTADO_NOVEDADES_ROWS_PER_PAGE",
  (take: TakeValue) => ({
    take,
  })
);

const setInitialStateNovedades = createAction(
  "SET_INITIAL_STATE_FILTRO_NOVEDADES"
);

const selectNegocio = createAction(
  "SELECT_NEGOCIO_FILTRO_NOVEDADES",
  (negocio: FiltroValue) => ({
    negocio,
  })
);

const selectSearchCriteria = createAction(
  "SELECT_SEARCH_CRITERIA_FILTRO_NOVEDADES",
  (searchCriteria: string) => ({
    searchCriteria,
  })
);

const selectCompania = createAction(
  "SELECT_COMPANIA_FILTRO_NOVEDADES",
  (compania: FiltroValue) => ({
    compania,
  })
);

const selectTipoNovedad = createAction(
  "SELECT_TIPO_NOVEDAD_FILTRO_NOVEDADES",
  (tipoNovedad: FiltroValue) => ({
    tipoNovedad,
  })
);

const selectInicioVigenciaDesde = createAction(
  "SELECT_FECHA_INICIO_VIGENCIA_DESDE_FILTRO_NOVEDADES",
  (inicioVigenciaDesde: FechaFiltro) => ({ inicioVigenciaDesde })
);

const selectInicioVigenciaHasta = createAction(
  "SELECT_FECHA_INICIO_VIGENCIA_HASTA_FILTRO_NOVEDADES",
  (inicioVigenciaHasta: FechaFiltro) => ({ inicioVigenciaHasta })
);

const selectFechaNovedadDesde = createAction(
  "SELECT_FECHA_NOVEDAD_DESDE_FILTRO_NOVEDADES",
  (fechaNovedadDesde: FechaFiltro) => ({ fechaNovedadDesde })
);

const selectFechaNovedadHasta = createAction(
  "SELECT_FECHA_NOVEDAD_HASTA_FILTRO_NOVEDADES",
  (fechaNovedadHasta: FechaFiltro) => ({ fechaNovedadHasta })
);

const descargaInited = createAction("GET_REPORTE_NOVEDADES_INITED");
const descargaCompleted = createAction("GET_REPORTE_NOVEDADES_COMPLETED");
const descargaFailed = createAction(
  "GET_REPORTE_NOVEDADES_FAILED",
  (error: unknown) => ({
    error,
  })
);

const buttonDescargaTextDefault = "EXPORTAR";

const filtrosNovedadesInitialState: FiltrosNovedadesState = {
  page: 0,
  take: 10,
  searchCriteria: "",
  inicioVigenciaDesde: "",
  inicioVigenciaHasta: "",
  fechaNovedadDesde: calculateDate(new Date(), -30),
  fechaNovedadHasta: new Date(),
  negocio: "",
  compania: "",
  tipoNovedad: "",
  buttonDescargaEnabled: true,
  buttonDescargaText: buttonDescargaTextDefault,
};

const filtrosNovedadesReducer = handleActions<FiltrosNovedadesState, any>(
  {
    [setInitialStateNovedades.toString()]: (): FiltrosNovedadesState => {
      return {
        ...filtrosNovedadesInitialState,
      };
    },
    [setPage.toString()]: (
      state: FiltrosNovedadesState,
      action: Action<{ page: number }>
    ): FiltrosNovedadesState => {
      return {
        ...state,
        page: action.payload.page,
      };
    },
    [setTake.toString()]: (
      state: FiltrosNovedadesState,
      action: Action<{ take: TakeValue }>
    ): FiltrosNovedadesState => {
      return {
        ...state,
        page: 0,
        take: action.payload.take,
      };
    },
    [selectFechaNovedadDesde.toString()]: (
      state: FiltrosNovedadesState,
      action: Action<{ fechaNovedadDesde: FechaFiltro }>
    ): FiltrosNovedadesState => {
      return {
        ...state,
        fechaNovedadDesde: action.payload.fechaNovedadDesde,
      };
    },
    [selectFechaNovedadHasta.toString()]: (
      state: FiltrosNovedadesState,
      action: Action<{ fechaNovedadHasta: FechaFiltro }>
    ): FiltrosNovedadesState => {
      return {
        ...state,
        fechaNovedadHasta: action.payload.fechaNovedadHasta,
      };
    },
    [selectInicioVigenciaDesde.toString()]: (
      state: FiltrosNovedadesState,
      action: Action<{ inicioVigenciaDesde: FechaFiltro }>
    ): FiltrosNovedadesState => {
      return {
        ...state,
        inicioVigenciaDesde: action.payload.inicioVigenciaDesde,
      };
    },
    [selectInicioVigenciaHasta.toString()]: (
      state: FiltrosNovedadesState,
      action: Action<{ inicioVigenciaHasta: FechaFiltro }>
    ): FiltrosNovedadesState => {
      return {
        ...state,
        inicioVigenciaHasta: action.payload.inicioVigenciaHasta,
      };
    },
    [selectCompania.toString()]: (
      state: FiltrosNovedadesState,
      action: Action<{ compania: FiltroValue }>
    ): FiltrosNovedadesState => {
      return {
        ...state,
        compania: action.payload.compania,
      };
    },
    [selectTipoNovedad.toString()]: (
      state: FiltrosNovedadesState,
      action: Action<{ tipoNovedad: FiltroValue }>
    ): FiltrosNovedadesState => {
      return {
        ...state,
        tipoNovedad: action.payload.tipoNovedad,
      };
    },
    [selectSearchCriteria.toString()]: (
      state: FiltrosNovedadesState,
      action: Action<{ searchCriteria: string }>
    ): FiltrosNovedadesState => {
      return {
        ...state,
        searchCriteria: action.payload.searchCriteria,
      };
    },
    [selectNegocio.toString()]: (
      state: FiltrosNovedadesState,
      action: Action<{ negocio: FiltroValue }>
    ): FiltrosNovedadesState => {
      return {
        ...state,
        negocio: action.payload.negocio,
      };
    },
    [descargaInited.toString()]: (
      state: FiltrosNovedadesState
    ): FiltrosNovedadesState => {
      return {
        ...state,
        buttonDescargaEnabled: false,
        buttonDescargaText: "EXPORTANDO...",
      };
    },
    [descargaCompleted.toString()]: (
      state: FiltrosNovedadesState
    ): FiltrosNovedadesState => {
      return {
        ...state,
        buttonDescargaEnabled: true,
        buttonDescargaText: buttonDescargaTextDefault,
      };
    },
    [descargaFailed.toString()]: (
      state: FiltrosNovedadesState
    ): FiltrosNovedadesState => {
      return {
        ...state,
        buttonDescargaEnabled: true,
        buttonDescargaText: buttonDescargaTextDefault,
      };
    },
  },
  filtrosNovedadesInitialState
);

interface DescargaReporteParams {
  negocio?: FiltroValue;
  compania?: FiltroValue;
  tipoNovedad?: FiltroValue;
  searchCriteria?: string;
  fechaNovedadDesde?: FechaFiltro;
  fechaNovedadHasta?: FechaFiltro;
  inicioVigenciaDesde?: FechaFiltro;
  inicioVigenciaHasta?: FechaFiltro;
}

const descargarReporte = (data: DescargaReporteParams) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: ServicesReportes
  ) => {
    try {
      dispatch(descargaInited());

      const request: GetReporteNovedadesRequest = {
        ...data,
        negocio: data.negocio ? String(data.negocio) : undefined,
        compania: data.compania ? String(data.compania) : undefined,
        tipoNovedad: data.tipoNovedad ? String(data.tipoNovedad) : undefined,
      };

      const response = await services.api.reportes().getNovedades(request);

      // create a fake anchor and click it programatically to
      // force the file to download
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function (this: XMLHttpRequest) {
        if (this.readyState === 4 && this.status === 200) {
          var downloadUrl = URL.createObjectURL(xhttp.response);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style.display = "none";
          a.href = downloadUrl;
          a.download = "";
          a.click();
        }
      };

      xhttp.open("GET", response.url, true);
      xhttp.responseType = "blob";
      xhttp.send();

      dispatch(descargaCompleted());
    } catch (error) {
      console.error(error);
      dispatch(descargaFailed(error));
      // El backend explica qué hacer cuando el rango es muy largo o hay demasiados
      // registros, así que preferimos su mensaje antes que uno genérico.
      dispatch(
        queueMessage(
          (error as { responseStatus?: { message?: string } })?.responseStatus
            ?.message ||
            "Ocurrió un error al exportar las novedades. Intentá nuevamente."
        )
      );
    }
  };
};

export { filtrosNovedadesReducer };
export {
  setInitialStateNovedades,
  descargarReporte,
  setPage,
  setTake,
  selectSearchCriteria,
  selectFechaNovedadDesde,
  selectFechaNovedadHasta,
  selectInicioVigenciaDesde,
  selectInicioVigenciaHasta,
  selectNegocio,
  selectCompania,
  selectTipoNovedad,
};
